__turbopack_context__.v({
  "dropdown": "DuEkCG_dropdown",
  "item": "DuEkCG_item",
});
